import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import merge from 'deepmerge';

var customLoaderOptions = function customLoaderOptions(config, loader, defaultOptions) {
  var _a;

  var customOptions = (_a = config.loaders) === null || _a === void 0 ? void 0 : _a[loader];
  return typeof defaultOptions === 'object' && typeof customOptions === 'object' ? Object.assign(Object.assign({}, defaultOptions), customOptions) : defaultOptions;
};

var defaultPresets = ['react', 'react-docgen-typescript'];
var defaultCompileProps = {
  presets: defaultPresets
};
var defBundleName = 'component-controls.js';
var defCssFileName = 'component-controls.css';

var concatMerge = function concatMerge(dest, src) {
  return [].concat(_toConsumableArray(dest), _toConsumableArray(src));
};

var deepMerge = function deepMerge(a, b) {
  return merge(a, b, {
    arrayMerge: concatMerge
  });
};

var mergeArrays = function mergeArrays(dest, src) {
  var result = src.length > 0 ? src.map(function (s, idx) {
    return typeof s === 'object' && typeof dest[idx] === 'object' && idx < dest.length ? mergeConfig(dest[idx], s) : s;
  }) : src;
  return result;
};

var mergeConfig = function mergeConfig(a, b) {
  return merge(a, b, {
    arrayMerge: mergeArrays,
    customMerge: function customMerge(key) {
      return function (src, dest) {
        return key === 'tabs' ? dest || src : mergeConfig(src, dest);
      };
    }
  });
};

var deepMergeReplaceArrays = function deepMergeReplaceArrays(a, b) {
  return merge(a, b, {
    arrayMerge: function arrayMerge(dest, src) {
      return src;
    }
  });
};

var deepmerge = merge;
export { deepmerge as a, defaultCompileProps as b, customLoaderOptions as c, deepMerge as d, defBundleName as e, defCssFileName as f, deepMergeReplaceArrays as g, mergeConfig as m };